import Reveal from '../components/Reveal';
import features from '../data/features';

export default function Features() {
  return (
    <div className="features-bg" id="features">
      <div className="section">
        <Reveal>
          <p className="section-label">What's Inside</p>
          <h2 className="section-title">Everything a Word Game Should Be</h2>
          <p className="section-sub">
            18 features crafted to keep you coming back — from offline play to global leaderboards.
          </p>
        </Reveal>
        <div className="features-grid">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={i * 50}>
              <div className="feature-card">
                <span className="feature-icon">{f.icon}</span>
                <div className="feature-title">{f.title}</div>
                <p className="feature-desc">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
